import useInView from '../UseInView/useInView';
import styles from './reveal-image.module.scss';

const RevealImage = ({
    src,
    alt = '',
    wrapperStyle = {},
    imageStyle = {},
    rollUpColor = '#bbb', // default gray
}) => {
    const [ref, visible] = useInView();

    const mergedWrapperStyle = {
        ...wrapperStyle,
        width: imageStyle?.width || '100%',
    };

    return (
        <div ref={ref} className={styles.imageWrapper} style={mergedWrapperStyle}>
            <div
                className={`${styles.overlay} ${visible ? styles.slideUp : ''}`}
                style={{ backgroundColor: rollUpColor }}
            />
            <img
                src={src}
                alt={alt}
                loading='lazy'
                className={`${styles.revealImage} ${visible ? styles.revealImageVisible : ''}`}
                style={{ display: 'block', width: '100%', ...imageStyle }}
            />
        </div>
    );
};

export default RevealImage;
